import React from 'react';
export interface MaybeFragment {
  shouldShowFragment: boolean;
  suppressChildren?: boolean;
}

export const withMaybeFragment = <T,>(
  WrappedComponent: React.ComponentType<T>
) => {
  const Toggler: React.FC<MaybeFragment & T> = ({
    shouldShowFragment,
    suppressChildren = false,
    children,
    ...passThroughProps
  }) => {
    if (shouldShowFragment) {
      if (suppressChildren) {
        return <React.Fragment />;
      }
      return <React.Fragment>{children}</React.Fragment>;
    }
    return (
      <WrappedComponent {...(passThroughProps as unknown as T)}>
        {children}
      </WrappedComponent>
    );
  };
  return Toggler;
  //shouldShowFragment() ? React.Fragment : WrappedComponent
};
